// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Wisdom",
  bookSlug: "wisdom",
  chapter: 6,
  argument: "An address to princes to seek after wisdom: she is easily found by those that seek her.",
  verses: [
    { n: 1, text: "Wisdom is better than strength: and a wise man is better than a strong man." },
    { n: 2, text: "Hear, therefore, ye kings, and understand, learn, ye that are judges of the ends of the earth." },
    { n: 3, text: "Give ear, you that rule the people, and that please yourselves in multitudes of nations:" },
    { n: 4, text: "For power is given you by the Lord, and strength by the Most High, who will examine your works: and search out your thoughts:" },
    { n: 5, text: "Because being ministers of his kingdom, you have not judged rightly, nor kept the law of justice, nor walked according to the will of God." },
    { n: 6, text: "Horribly and speedily will he appear to you: for a most severe judgment shall be for them that bear rule." },
    { n: 7, text: "For to him that is little, mercy is granted: but the mighty shall be mightily tormented." },
    { n: 8, text: "For God will not except any man's person, neither will he stand in awe of any man's greatness: for he made the little and the great, and he hath equally care of all." },
    { n: 9, text: "But a greater punishment is ready for the more mighty." },
    { n: 10, text: "To you, therefore, O kings, are these my words, that you may learn wisdom, and not fall from it." },
    { n: 11, text: "For they that have kept just things justly, shall be justified: and they that have learned these things, shall find what to answer." },
    { n: 12, text: "Covet ye, therefore, my words, and love them, and you shall have instruction." },
    { n: 13, text: "Wisdom is glorious, and never fadeth away, and is easily seen by them that love her, and is found by them that seek her." },
    { n: 14, text: "She preventeth them that covet her, so that she first sheweth herself unto them." },
    { n: 15, text: "He that awaketh early to seek her, shall not labour: for he shall find her sitting at his door." },
    { n: 16, text: "To think, therefore, upon her, is perfect understanding: and he that watcheth for her, shall quickly be secure." },
    { n: 17, text: "For she goeth about seeking such as are worthy of her, and she sheweth herself to them cheerfully in the ways, and meeteth them with all providence." },
    { n: 18, text: "For the beginning of her is the most true desire of discipline." },
    { n: 19, text: "And the care of discipline is love: and love is the keeping of her laws: and the keeping of her laws is the firm foundation of incorruption:" },
    { n: 20, text: "And incorruption bringeth near to God." },
    { n: 21, text: "Therefore the desire of wisdom bringeth to the everlasting kingdom." },
    { n: 22, text: "If then your delight be in thrones, and sceptres, O ye kings of the people, love wisdom, that you may reign for ever." },
    { n: 23, text: "Love the light of wisdom, all ye that bear rule over peoples." },
    { n: 24, text: "Now what wisdom is, and what was her origin, I will declare: and I will not hide from you the mysteries of God, but will seek her out from the beginning of her birth, and bring the knowledge of her to light, and will not pass over the truth:" },
    { n: 25, text: "Neither will I go with consuming envy: for such a man shall not be partaker of wisdom." },
    { n: 26, text: "Now the multitude of the wise is the welfare of the whole world: and a wise king is the upholding of the people." },
    { n: 27, text: "Receive, therefore, instruction by my words, and it shall be profitable to you." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Wisdom, &c. This is not in Greek, and seems out of its place, being taken from Proverbs xvi. 32., or Ecclesiastes ix. 16. (Calmet) — The connection with the preceding is observable in the next verse.", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "Kings. The author puts these words in the mouth of Solomon to give them greater weight, (Calmet) or rather (Haydock) as the inspiration of God is the most unexceptionable authority, and it would be of no service to introduce a false personage speaking; these nine first chapters were written by Solomon, though the original has since disappeared. This has been the case with respect to the original text of Tobias and Judith, (Houbigant) as well as to that of the many canticles and parables which Solomon wrote.", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "Power. All power is from God, and to be respected, even though the magistrate should sometimes abuse his authority. (Worthington) (Romans xiii. 1.) — They must render an account to the common master, 2 Paralipomenon xix. 6.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Rule. How severely did God chastise Moses, David, and Ezechias.", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "Little, and ignorant. Those in power ought to know, and to perform their duty.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Equally. In proportion to their exigencies, or he punishes all as they deserve. It is not clear that he speaks of grace, as the Pelagians would assert, (Calmet) abusing this passage. See St. Augustine, ep. cvi., or clxxxvii.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Mighty. This cannot be too often inculcated, (", attribution: "Haydock" }
    ] },
    { verse: 10, notes: [
      { text: "Kings. Septuagint, \"tyrants.\" But this title was not formerly odious.", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Just. Septuagint, \"holy.\" The Jewish judges were generally priests. — Answer. The sovereign judge, to whom Job and David confidently appeal.", attribution: "Haydock" }
    ] },
    { verse: 13, notes: [
      { text: "Seek her. With the assistance of divine grace, Deuteronomy xxx. 11., and Romans x. 6. The advantages of wisdom invite us to seek her.", attribution: "Calmet" }
    ] },
    { verse: 15, notes: [
      { text: "Door. Ready to introduce herself. (Haydock)", attribution: "Proverbs i. 20., and viii. 34., and ix. 1." }
    ] },
    { verse: 16, notes: [
      { text: "Think. With eager desire to be guided by her maxims.", attribution: "Calmet" }
    ] },
    { verse: 17, notes: [
      { text: "Providence. To facilitate our just designs, Proverbs ix. (Menochius) — She is on the watch to save us.", attribution: "Haydock" }
    ] },
    { verse: 18, notes: [
      { text: "Discipline. We must begin with a sincere desire of instruction, and submit to correction, (Calmet) if we would come near to God,", attribution: "Haydock" }
    ] },
    { verse: 20, notes: [
      { text: "(Haydock) — Wisdom is attained by this gradation.", attribution: "Worthington" }
    ] },
    { verse: 21, notes: [
      { text: "Everlasting is not in Greek. Wisdom conducts to the throne, (", attribution: "Haydock" }
    ] },
    { verse: 22, notes: [
      { text: "; Calmet) which shall last for ever. (Haydock) — The sense of the Vulgate is very just, chap. v. 17.", attribution: "Haydock" }
    ] },
    { verse: 24, notes: [
      { text: "Now. The pagans attributed the invention of wisdom to Socrates, or to Pythagoras. But she proceeds from the bosom of God, and was practised long before their times.", attribution: "Haydock" }
    ] },
    { verse: 25, notes: [
      { text: "Envy. I will not imitate such, chap. vii. 13. Wisdom ought to be diffused.", attribution: "Calmet" }
    ] },
    { verse: 26, notes: [
      { text: "World. The wicked is ransomed and healed by the wise.", attribution: "Philo." }
    ] },
  ],
};

export default chapter;
